const FontFaceObserver = require('fontfaceobserver');

function asyncLoadFont(family, toggleClass, loadedClass) {
  if (document.documentElement.className.indexOf(toggleClass) === -1) {
    return Promise.resolve();
  }

  const regularFFO = new FontFaceObserver(family);
  const boldFFO = new FontFaceObserver(family, { weight: 'bold' });

  return Promise.all([regularFFO.load(), boldFFO.load()])
    .then(() => {
      document.documentElement.className += ` ${loadedClass}`;
    })
    .catch(error => {
      console.log(`Error loading ${family} font: ${error}`);
    });
}

function loadReithFont() {
  const myNav = navigator.userAgent.toLowerCase();
  const oldIE = (myNav.indexOf('msie') !== -1) && parseInt(myNav.split('msie')[1], 10) <= 10;
  const supported = !oldIE;

  if (!supported) {
    return Promise.resolve();
  }

  // We don't need to wait for Serif as orbit does not use it.
  // If this font is not loaded in time for layout it will be fine.
  asyncLoadFont('ReithSerif', 'b-reith-serif-font', 'b-reith-serif-loaded');
  // Return the result of serif load so Orbit can hold off nav layout
  // until we have the right font
  return asyncLoadFont('ReithSans', 'b-reith-sans-font', 'b-reith-sans-loaded');
}

if (bbcpage.isModal()) {
  loadReithFont();
} else {
  require(['orb/features/masthead/_layoutprimarynav', 'orb/nav'], (layout, nav) => {
    loadReithFont().then(nav.refresh());
  });
}

